import { TkGetCodeList } from "../../utils/TkGetCode";
import { OkOrNoFlug } from "../../assets/data/Constants";

const infoManual = (
  <>
    「俸給の調整額」対象手当を<span>現在申請中</span>です。
    <br />
    ・申請中の手当の審査結果が退職手当金に影響を受けない方は、「影響を受けないので退職手当金を申請する」を選択してください。
    <br />
    ・影響がある場合は、機構からの審査結果通知メールを受信後、手続きを行ってください。
  </>
);

const radioPropsList: any = [
  { value: "1", label: "影響を受けないので退職手当金を請求する" },
  { value: "2", label: "審査結果を待つ" },
];

const itemList = [
  {
    lineTitle: "1.退職者の情報について",
  },
  {
    keyword: "check1",
    title: "①「俸給の調整額」対象手当は最新の状況に更新されていますか？",
    funcButton: "新たな手当を追加申請する",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    confimButtonContext: "内容を確認する",
    confirmNavi: "/SCRC040103",
    funcNavi: "/SCRC040004",
  },
  {
    keyword: "check2",
    title: "②退職月の俸給額（俸給月額、俸給の調整額）に更新されていますか？",
    funcButton: "退職月の俸給額を更新する",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    confimButtonContext: "内容を確認する",
    confirmNavi: "/SCRC060116",
    funcNavi: "/SCRC060116",
  },
  {
    keyword: "check3",
    title: "③退職月まで従業状況は更新されていますか？",
    funcButton: "従業状況を更新する",
    radioPropsList: TkGetCodeList(OkOrNoFlug),
    confimButtonContext: "内容を確認する",
    confirmNavi: "/SCRC060112",
    funcNavi: "/SCRC060112",
  },
  {
    lineTitle: "2.源泉徴収票について",
  },
  {
    keyword: "check4",
    title: (
      <>
        都道府県の退職手当金制度等にも加入されている場合で、福祉医療機構よりも先に退職手当金が支払われる場合は、同制度等が発行する源泉徴収票が必要となります。なお、源泉徴収票は後から提出することも可能ですが、提出されるまでは退職所得の源泉徴収を行う都合上、退職手当金は支払われませんのでご留意ください。
        <br />
        ※当機構を先に退職手当金請求いただく場合は、源泉徴収票の添付は不要となります。
      </>
    ),
    useCheckBox: true,
    checkboxContext: "確認しました",
  },
  {
    lineTitle: "3.退職理由による必要な添付書類について",
  },
  {
    keyword: "check5",
    title: (
      <div>
        次の場合については、必要な添付書類がありますので、リンクをクリックして確認をしてください。
        <br />
        なお、書類は後から提出することも可能ですが、提出されるまでは、退職手当金は支払われませんのでご留意ください。
        <br />
        ①被共済職員が死亡したことにより退職する場合について
        <a
          target="_blank"
          rel="noreferrer"
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫①被共済職員が死亡したことにより退職する場合についての必要書類.pdf`}
        >
          （必要書類）
        </a>
        <br />
        ②退職理由が「業務上の傷病又は業務上の死亡」により退職する場合について
        <a
          target="_blank"
          rel="noreferrer"
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫②退職理由が「業務上の傷病又は業務上の死亡」により退職する場合についての必要書類.pdf`}
        >
          （必要書類）
        </a>
        <br />
        ③退職理由が「犯罪等による退職」により退職する場合について
        <a
          target="_blank"
          rel="noreferrer"
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫③退職理由が「犯罪等による退職」により退職する場合についての必要書類.pdf`}
        >
          （必要書類）
        </a>
      </div>
    ),
    useCheckBox: true,
    checkboxContext: "確認しました",
  },
  {
    lineTitle: "【確認事項】",
  },
  {
    keyword: "check6",
    title:
      "退職手当金請求の手続き方法、合算制度及び退職再加入について職員に説明していますか？",
    useCheckBox: true,
    checkboxContext: "説明している",
  },
];

const urlList = [
  {
    fileName: "職員説明資料（退職される皆様へ【PDF】）",
    href: "https://www.wam.go.jp/hp/wp-content/uploads/kyousai2022-1.pdf",
  },
  {
    fileName: "退職手当金シミュレーション",
    href: "https://www.wam.go.jp/content/wamnet/pcpub/top/taisyokuteate/",
  },
  {
    fileName: "退職再加入シミュレーション",
    href: "https://www.wam.go.jp/hp/guide-taisyokuteate-tabid-saikanyu/",
  },
];

export { infoManual, radioPropsList, itemList, urlList };
